export default "__VITE_ASSET__Dg9_otmv__"